import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowLeft, Shield, FileText, Lock, Users, Trash2, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";

export const TermosPrivacidade = () => {
  const [activeTab, setActiveTab] = useState("termos");

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center">
              <CalendarDays className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>
                Conforme a Resolução
              </h1>
              <p className="text-xs text-slate-500">Gestão Documental</p>
            </div>
          </Link>
          <Link to="/login">
            <Button variant="outline" size="sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Voltar
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="termos" className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              Termos de Uso
            </TabsTrigger>
            <TabsTrigger value="privacidade" className="flex items-center gap-2">
              <Shield className="w-4 h-4" />
              Política de Privacidade
            </TabsTrigger>
          </TabsList>

          {/* Termos de Uso */}
          <TabsContent value="termos">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
              <h1 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope' }}>
                Termos de Uso
              </h1>
              <p className="text-sm text-slate-500 mb-6">Última atualização: Fevereiro de 2026</p>

              <div className="space-y-6 text-slate-700">
                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">1. Aceitação dos Termos</h2>
                  <p>
                    Ao acessar ou utilizar o sistema "Conforme a Resolução", você concorda em cumprir e estar vinculado 
                    a estes Termos de Uso. Caso não concorde com qualquer parte destes termos, você não deverá utilizar 
                    nossos serviços.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">2. Descrição do Serviço</h2>
                  <p>
                    O "Conforme a Resolução" é um sistema de gestão documental desenvolvido para farmácias de manipulação, 
                    que oferece, entre outras, as seguintes funcionalidades:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                    <li>Controle de licenças e alvarás</li>
                    <li>Gestão de calibrações de equipamentos</li>
                    <li>Verificações diárias de rotina</li>
                    <li>Cadastro e gestão de funcionários</li>
                    <li>Armazenamento de documentos</li>
                    <li>Alertas de vencimentos</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">3. Cadastro e Conta</h2>
                  <p>
                    Para utilizar o sistema, você deverá criar uma conta fornecendo informações verdadeiras, completas 
                    e atualizadas. Você é responsável por manter a confidencialidade de sua senha e por todas as 
                    atividades realizadas por meio de sua conta.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">4. Uso Adequado</h2>
                  <p>Ao utilizar o sistema, você concorda em:</p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                    <li>Utilizar o sistema apenas para fins lícitos</li>
                    <li>Não compartilhar suas credenciais de acesso</li>
                    <li>Manter seus dados sempre atualizados</li>
                    <li>Não tentar acessar áreas restritas do sistema sem autorização</li>
                    <li>Não utilizar o sistema para armazenar conteúdo ilegal</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">5. Acesso Administrativo e Suporte</h2>
                  <p>
                    Para garantir a qualidade do serviço, a manutenção do sistema e o atendimento de suporte técnico, 
                    o administrador da plataforma poderá acessar os dados cadastrados pelos usuários. Este acesso 
                    será realizado exclusivamente para as seguintes finalidades:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                    <li>Prestação de suporte técnico e resolução de problemas reportados</li>
                    <li>Manutenção preventiva e corretiva do sistema</li>
                    <li>Verificação de integridade dos dados</li>
                    <li>Atendimento a solicitações do próprio usuário</li>
                  </ul>
                  <p className="mt-3 bg-blue-50 border border-blue-200 rounded-lg p-3 text-blue-800 text-sm">
                    <strong>Compromisso de Confidencialidade:</strong> Todos os acessos administrativos são realizados 
                    com estrita confidencialidade. Os dados acessados não serão compartilhados com terceiros, exceto 
                    nas hipóteses previstas na Política de Privacidade.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">6. Propriedade Intelectual</h2>
                  <p>
                    Todo o conteúdo do sistema, incluindo textos, gráficos, logotipos, ícones e software, é de 
                    propriedade exclusiva do "Conforme a Resolução" e está protegido pelas leis de direitos autorais 
                    e demais legislações aplicáveis.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">7. Limitação de Responsabilidade</h2>
                  <p>
                    O sistema é fornecido "como está", sem garantias de qualquer natureza. Não garantimos que o 
                    serviço será ininterrupto, livre de erros ou totalmente seguro. Não nos responsabilizamos por 
                    perdas ou danos decorrentes do uso do sistema, incluindo, mas não se limitando, à perda de dados.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">8. Cancelamento</h2>
                  <p>
                    Você pode cancelar sua conta a qualquer momento. Após o cancelamento, seus dados serão tratados 
                    de acordo com nossa Política de Privacidade, podendo ser excluídos mediante solicitação.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">9. Alterações nos Termos</h2>
                  <p>
                    Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. Alterações relevantes 
                    serão comunicadas por e-mail ou por meio do próprio sistema.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">10. Contato</h2>
                  <p>
                    Em caso de dúvidas sobre estes Termos de Uso, entre em contato pelo e-mail:
                    <a href="mailto:contato@conformearesolucao.com.br" className="text-teal-600 hover:underline ml-1">
                      contato@conformearesolucao.com.br
                    </a>
                  </p>
                </section>
              </div>
            </div>
          </TabsContent>

          {/* Política de Privacidade */}
          <TabsContent value="privacidade">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
              <h1 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope' }}>
                Política de Privacidade
              </h1>
              <p className="text-sm text-slate-500 mb-6">Última atualização: Fevereiro de 2026</p>

              <div className="space-y-6 text-slate-700">
                <section>
                  <p className="bg-teal-50 border border-teal-200 rounded-lg p-4 text-teal-800">
                    Esta Política de Privacidade descreve como coletamos, utilizamos e protegemos suas informações 
                    pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <Users className="w-5 h-5 text-teal-600" />
                    1. Dados que Coletamos
                  </h2>
                  <p className="mb-2">Coletamos os seguintes tipos de dados:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li><strong>Dados de cadastro:</strong> nome, e-mail, CPF, telefone e endereço</li>
                    <li><strong>Dados da farmácia:</strong> nome, CNPJ, endereço e responsável técnico</li>
                    <li><strong>Dados de funcionários:</strong> informações cadastrais dos colaboradores</li>
                    <li><strong>Documentos:</strong> arquivos enviados ao sistema (PDFs, imagens, entre outros)</li>
                    <li><strong>Dados de uso:</strong> registros de acesso, logs e ações realizadas no sistema</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <FileText className="w-5 h-5 text-teal-600" />
                    2. Finalidade do Tratamento
                  </h2>
                  <p className="mb-2">Os dados coletados são utilizados para as seguintes finalidades:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Fornecer, operar e manter nossos serviços</li>
                    <li>Gerenciar sua conta e processos de autenticação</li>
                    <li>Enviar alertas de vencimentos e notificações importantes</li>
                    <li>Gerar relatórios e documentos</li>
                    <li>Melhorar continuamente nossos serviços e funcionalidades</li>
                    <li>Cumprir obrigações legais e regulatórias</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <Lock className="w-5 h-5 text-teal-600" />
                    3. Segurança dos Dados
                  </h2>
                  <p>
                    Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados pessoais, incluindo:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                    <li>Criptografia de senhas</li>
                    <li>Conexões seguras (HTTPS)</li>
                    <li>Controle de acesso por autenticação</li>
                    <li>Isolamento de dados por farmácia (arquitetura multi-tenant)</li>
                    <li>Backups periódicos</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <Shield className="w-5 h-5 text-teal-600" />
                    4. Compartilhamento de Dados
                  </h2>
                  <p>
                    <strong>Não vendemos seus dados pessoais.</strong> O compartilhamento de informações poderá 
                    ocorrer apenas nas seguintes situações:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                    <li>Mediante seu consentimento explícito</li>
                    <li>Para cumprimento de obrigações legais ou regulatórias</li>
                    <li>Com prestadores de serviços essenciais à operação do sistema (como hospedagem e envio de e-mails), sempre sob obrigações de confidencialidade</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <Trash2 className="w-5 h-5 text-teal-600" />
                    5. Seus Direitos (LGPD)
                  </h2>
                  <p className="mb-2">Nos termos da LGPD, você possui os seguintes direitos:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li><strong>Acesso:</strong> solicitar uma cópia dos seus dados pessoais</li>
                    <li><strong>Correção:</strong> solicitar a correção de dados incompletos, inexatos ou desatualizados</li>
                    <li><strong>Exclusão:</strong> solicitar a exclusão de seus dados pessoais</li>
                    <li><strong>Portabilidade:</strong> receber seus dados em formato estruturado e interoperável</li>
                    <li><strong>Revogação:</strong> retirar seu consentimento a qualquer momento</li>
                    <li><strong>Informação:</strong> saber com quem seus dados foram compartilhados</li>
                  </ul>
                  <p className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3 text-amber-800 text-sm">
                    Para exercer seus direitos, envie um e-mail para:
                    <a href="mailto:administracao@conformearesolucao.com.br" className="font-medium ml-1">
                      administracao@conformearesolucao.com.br
                    </a>
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">6. Retenção de Dados</h2>
                  <p>
                    Seus dados pessoais serão mantidos enquanto sua conta estiver ativa ou pelo tempo necessário 
                    para cumprir obrigações legais e regulatórias. Após a exclusão da conta, os dados serão 
                    removidos em até 30 (trinta) dias, salvo nos casos em que houver obrigação legal de retenção.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">7. Cookies</h2>
                  <p>
                    Utilizamos apenas cookies essenciais para o funcionamento do sistema, como tokens de autenticação. 
                    Não utilizamos cookies de rastreamento, publicidade ou marketing.
                  </p>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <Mail className="w-5 h-5 text-teal-600" />
                    8. Contato do Encarregado de Proteção de Dados (DPO)
                  </h2>
                  <p>
                    Para questões relacionadas à proteção de dados pessoais, entre em contato com nosso Encarregado 
                    de Proteção de Dados:
                  </p>
                  <div className="mt-3 bg-slate-50 rounded-lg p-4">
                    <p><strong>E-mail:</strong> administracao@conformearesolucao.com.br</p>
                    <p className="mt-1"><strong>Prazo de resposta:</strong> até 15 (quinze) dias úteis</p>
                  </div>
                </section>

                <section>
                  <h2 className="text-lg font-semibold text-slate-900 mb-3">9. Alterações nesta Política</h2>
                  <p>
                    Esta Política de Privacidade poderá ser atualizada periodicamente. Alterações relevantes serão 
                    comunicadas por e-mail ou por meio do próprio sistema.
                  </p>
                </section>
              </div>
            </div>
          </TabsContent>
        </Tabs>

        {/* Footer */}
        <div className="mt-8 text-center text-sm text-slate-500">
          <p>© 2026 Conforme a Resolução. Todos os direitos reservados.</p>
        </div>
      </main>
    </div>
  );
};

export default TermosPrivacidade;
